<template>
    <div>

         <!-- ======= CAROUSEL ======= -->
     <div class="text-center">
      <div id="carouselExampleIndicators" class="carousel slide" data-bs-ride="carousel" style="height: auto !important;">
         <div class="carousel-indicators">
            <button v-for="(data, idx) in list_slider"
               :key="data.id" type="button"
               data-bs-target="#carouselExampleIndicators"
               :data-bs-slide-to="idx"
               :class="cek_active(idx)">
            </button>
         </div>
         <div class="carousel-inner">
            <div v-for="(data, idx) in list_slider" :key="data.id" :class="'carousel-item '+cek_active(idx)">
                <div class="carousel-item-wrapper">
                    <img class="carousel-image" :src="file_path + data.file" alt="First slide" />
                </div>
            </div>
         </div>
         <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators"
            data-bs-slide="prev">
            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
            <span class="visually-hidden">Previous</span>
         </button>
         <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators"
            data-bs-slide="next">
            <span class="carousel-control-next-icon" aria-hidden="true"></span>
            <span class="visually-hidden">Next</span>
         </button>
      </div>
   </div>
   <!-- ======= CAROUSEL ======= -->
        <!-- main-area -->
        <main class="fix">
            <!-- testimonial-area -->
            <section class="testimonial__area-four testimonial__bg testimonial__bg-two position-relative">
                <div class="bg-img position-absolute top-0 bottom-0 start-0 w-100 h-100" data-background="assets/img/bg/h3_testimonial_bg.jpg"></div>
                <div class="container">
                    <div class="row align-items-center justify-content-center">
                        <div class="col-lg-5 col-md-8">
                            
                            
                            <div class="testimonial__img-wrap-two">
                                <img :src="file_path + sambutan_foto" alt="Apexa" style="width: 400px; height: 500px;" /> 
                                <div class="testimonial__img-shape-two">
                                    <img src="assets/img/images/h3_testimonial_shape01.png" alt="Apexa" class="alltuchtopdown" />
                                    <img src="assets/img/images/inner_testimonial_shape.png" alt="Apexa" class="rotateme" />
                                    <img src="assets/img/images/h3_testimonial_shape03.png" alt="Apexa" />
                                </div>
                                
                            </div>
                            
                        </div>
                        
                        <div class="col-lg-7">
                            
                            <div class="testimonial__item-wrap">
                                <div class="swiper-container testimonial-active-two">
                                    <div class="swiper-wrapper">
                                        <div class="swiper-slide">
                                            <div class="testimonial__item-three">
                                              
                                                <p v-html="sambutan_isi"></p>
                                                <!-- <div class="testimonial__bottom">
                                                    <div class="testimonial__info-three">
                                                        <h4 class="title" v-html="sambutan_nama" ></h4>
                                                        <span>Kepala Dinas Pengendalian Penduduk dan KB</span>
                                                    </div>
                                                    <div class="testimonial__icon">
                                                        <img src="assets/img/icon/quote02.svg" alt="Apexa" />
                                                    </div>
                                                </div> -->
                                            </div>
                                            
                                        </div>
                                        
                                       
                                    </div>
                                    
                            
                                </div>
                                
                            </div>
                            
                        </div>
                    </div>
                </div>
            </section>
            <!-- testimonial-area-end -->

            <!-- blog-post-area -->
            <section class="blog__post-area-five marketing__area-home12">
                <div class="container">
                    <div class="row justify-content-center">
                        <div class="col-xl-6">
                            <div class="section-title text-center mb-50 tg-heading-subheading animation-style3">
                                <!-- <span class="sub-title">Berita Terbaru</span> -->
                                <h5 class="title tg-element-title">Berita Terbaru</h5 >
                            </div>
                        </div>
                    </div>

                    <div class="row justify-content-center">
                        <div class="col-xl-4 col-lg-6 col-md-10"  v-for="data in list_berita" :key="data.id">
                            <div class="blog-post-item blog__post-three shine-animate-item">
                                <div class="blog-post-thumb blog__post-thumb-three">
                                    <a  @click="push_berita(data.id)" href="javascript:void(0);" :title="data.judul"  class="shine-animate"><img :src="file_path+data.foto" alt="Apexa" /></a>
                                </div>
                                <div class="blog-post-content blog__post-content-three">
                                    <a href="javascript:void(0);" class="post-tag">{{data.kategori_id}}</a>
                                    <h2 class="title">
                                        <a  @click="push_berita(data.id)" href="javascript:void(0);" :title="data.judul" ><span>{{ truncateText(data.judul, 80) }}</span></a>
                                        </h2>
                                    <div class="blog-post-meta mb-20">
                                        <ul class="list-wrap">
                                            <li><i class="fas fa-calendar-alt"></i>{{convert_tgl(data.createAt)}}</li>
                                        </ul>
                                    </div>
                                    <!-- <a @click="push_berita(data.id)" href="javascript:void(0);" :title="data.judul"  class="btn">Baca Selengkapnya</a> -->
                                </div>
                            </div>
                        </div>
                    </div>
                    
                </div>
                <div class="blog-shape-wrap">
                    <img src="assets/img/images/h5_blog_shape01.png" alt="Apexa" data-aos="fade-right" data-aos-delay="400" />
                    <img src="assets/img/images/h5_blog_shape02.png" alt="Apexa" data-aos="fade-left" data-aos-delay="400" />
                </div>

                <div class="project-content-bottom">
                <!-- <a href="javascript:void(0);" class="btn">Foto Lainnya</a> -->
                <router-link to="/BeritaOPD" class="btn">Berita Lainnya</router-link>
            </div>
            </section>
            <!-- blog-post-area-end -->


            <section class="about__area-two about__bg" data-background="assets/img/bg/about_bg.jpg">
                <div class="container">
                    <div class="row justify-content-center">
                        <div class="col-xl-6 col-lg-7">
                            <div class="section-title text-center mb-50 tg-heading-subheading animation-style3">
                                <span class="sub-title">Gallery</span>
                                <h2 class="title tg-element-title">Foto Terbaru</h2>
                            </div>
                        </div>
                    </div>
                    <div class="row gutter-24">
                        <div class="col-lg-4 col-md-6" v-for="data in list_foto" :key="data.id">
                            <div class="project__item-two">
                                <div class="project__thumb-two">
                                    <img :src="file_path+data.file" alt="">
                                </div>
                                <div class="project__content-two">
                                    <h2 class="title"><a @click.prevent="showModal(data)">{{data.judul}}</a></h2>
                                    <span>{{convert_tgl(data.createAt)}}</span>
                                    <div class="link-arrow link-arrow-two">
                                        <a @click.prevent="showModal(data)">
                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 15" fill="none">
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M17.6293 3.27956C17.7117 2.80339 17.4427 2.34761 17.0096 2.17811C16.9477 2.15384 16.8824 2.13551 16.8144 2.12375L6.96087 0.419136C6.4166 0.325033 5.89918 0.689841 5.80497 1.23409C5.71085 1.77828 6.0757 2.29576 6.61988 2.38991L14.0947 3.68293L1.3658 12.6573C0.914426 12.9756 0.806485 13.5994 1.12473 14.0508C1.44298 14.5022 2.06688 14.6101 2.51825 14.2919L15.2471 5.31752L13.954 12.7923C13.8599 13.3365 14.2248 13.854 14.7689 13.9481C15.3132 14.0422 15.8306 13.6774 15.9248 13.1332L17.6293 3.27956Z" fill="currentcolor" />
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M17.6293 3.27956C17.7117 2.80339 17.4427 2.34761 17.0096 2.17811C16.9477 2.15384 16.8824 2.13551 16.8144 2.12375L6.96087 0.419136C6.4166 0.325033 5.89918 0.689841 5.80497 1.23409C5.71085 1.77828 6.0757 2.29576 6.61988 2.38991L14.0947 3.68293L1.3658 12.6573C0.914426 12.9756 0.806485 13.5994 1.12473 14.0508C1.44298 14.5022 2.06688 14.6101 2.51825 14.2919L15.2471 5.31752L13.954 12.7923C13.8599 13.3365 14.2248 13.854 14.7689 13.9481C15.3132 14.0422 15.8306 13.6774 15.9248 13.1332L17.6293 3.27956Z" fill="currentcolor" />
                                            </svg>
                                        </a>
                                    </div>

                                    
                                </div>
                            </div>
                        </div>
                        
                    </div>
                </div>
                <div class="about__shape-wrap-two">
                <img src="assets/img/images/h2_about_shape01.png" alt="" data-parallax='{"x" : -80 , "y" : 80 , "rotateZ":80}'>
                <img src="assets/img/images/h2_about_shape02.png" alt="" data-parallax='{"y" : 100 }'>
                <img src="assets/img/images/h2_about_shape03.png" alt="" data-aos="fade-left" data-aos-delay="400">
            </div>
            <div class="project-content-bottom">
                <!-- <a href="javascript:void(0);" class="btn">Foto Lainnya</a> -->
                <router-link to="/FotoOPD" class="btn">Foto Lainnya</router-link>
            </div>

                                
            </section>
            <!-- project-area-end -->

            <!-- Jika ≤ 5: Static Centered Display -->
            <div v-if="list_link_terkait.length <= 5" class="brand-area">
            <div class="container">
                <div class="d-flex justify-content-center align-items-center flex-wrap" style="gap: 40px;">
                <div v-for="data in list_link_terkait" :key="data.id" class="brand-item" style="width: 160px; text-align: center;">
                    <a :href="data.url" target="_blank" rel="noopener noreferrer">
                    <img :src="file_path + data.file" alt="" style="height: 80px; width: 100%; object-fit: contain;">
                    </a>
                </div>
                </div>
            </div>
            </div>

            <!-- Jika > 5: Swiper Active -->
            <div v-else class="brand-area">
            <div class="container">
                <div class="swiper-container brand-active">
                <div class="swiper-wrapper">
                    <div class="swiper-slide" v-for="data in list_link_terkait" :key="data.id">
                    <div class="brand-item">
                        <a :href="data.url" target="_blank" rel="noopener noreferrer">
                        <img :src="file_path + data.file" alt="" style="height: 80px; width: 100%; object-fit: contain;">
                        </a>
                    </div>
                    </div>
                </div>
                </div>
            </div>
            </div>




        </main>
    </div>

    <div class="modal fade" id="fotoModal" tabindex="-1" aria-labelledby="fotoModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-lg">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="fotoModalLabel">{{form.judul }}</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Tutup"></button>
                </div>
                <div class="modal-body text-center">
                    <img :src="file_path + form.file" alt="Foto Detail" class="img-fluid mb-3" />
                    <p>{{ form.deskripsi }}</p>
                </div>
                </div>
            </div>
        </div>

</template>

<script>
import { useStore } from 'vuex'
import Swiper from 'swiper/bundle'
import 'swiper/css/bundle'
const URL_APP = 'https://server-web.konaweselatankab.go.id/';
const ADD_URL_LINK_TERKAIT = URL_APP + "api/v1/web_publish_link_terkait/";

export default {
  data() {
    const store = useStore()
    const baseURL = store.state.URL_APP

    return {
      unit_kerja: store.state.UNIT_KERJA,
      file_path: baseURL + 'uploads/',
      sambutan_nama: '',
      sambutan_foto: '',
      sambutan_isi: '',
      list_slider: [],
      list_berita: [],
      list_foto: [],
      list_link_terkait: [],
      form : {
                        id : '',
                        judul : '',
                        deskripsi : '',
                        file : '',
                        unit_kerja : '',
                        status : '',
                        createBy : '',
                        createAt : '',
                    },
    }
  },
  mounted() {
     // Inisialisasi Swiper
        // new window.Swiper('.brand-active', {
        //     slidesPerView: 5,
        //     spaceBetween: 30,
        //     loop: true,
        //     autoplay: {
        //     delay: 2000,
        //     disableOnInteraction: false,
        //     },
        //     breakpoints: {
        //     320: { slidesPerView: 2 },
        //     768: { slidesPerView: 3 },
        //     1024: { slidesPerView: 5 }
        //     }
        // })
        this.$nextTick(() => {
            if (this.list_link_terkait.length > 5) {
                new Swiper('.brand-active', {
                loop: false, // TIDAK perlu loop
                centeredSlides: false,
                slidesPerView: 5,
                spaceBetween: 40,
                autoplay: {
                    delay: 3000,
                    disableOnInteraction: false
                },
                breakpoints: {
                    320: { slidesPerView: 2 },
                    768: { slidesPerView: 3 },
                    992: { slidesPerView: 4 },
                    1200: { slidesPerView: 5 }
                }
                });
            }
            });


    this.getSambutan()
    this.getSlider();
    this.getListBerita();
    this.getFoto();
    this.getLinkTerkait();
  },
  methods: {

    showModal(data) {
                this.form = data;

                // trigger Bootstrap Modal (v5)
                // eslint-disable-next-line no-undef
                const modal = new bootstrap.Modal(document.getElementById('fotoModal'));
                modal.show();
            },

    truncateText(text, limit = 50) {
    if (!text) return '';
    return text.length > limit ? text.substring(0, limit) + '...' : text;
  },

    cek_active(index) {
      return index === 0 ? 'active' : '';
    },
    getSambutan() {
      fetch(this.$store.state.URL_SAMBUTAN + "view", {
        headers: { 'content-type': 'application/json' },
        })
        .then(res => res.json())
        .then(res_data => {
          const sambutan = res_data[0]
          this.sambutan_nama = sambutan.nama
          this.sambutan_foto = sambutan.foto
          this.sambutan_isi = sambutan.isi
        //   console.log(res_data);
          
        })
    },
    getLinkTerkait: function () {
        fetch(ADD_URL_LINK_TERKAIT, {
            method: "POST",
            headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token,
            },
            body: JSON.stringify({
                unit_kerja: this.unit_kerja,
            }),
        })
        .then((res) => res.json())
        .then((res_data) => {
        this.list_link_terkait = res_data;
        // console.log(res_data);

        // 🛠 Inisialisasi Swiper setelah DOM ter-update
        this.$nextTick(() => {
            new Swiper(".brand-active", {
            loop: true,
            spaceBetween: 30,
            slidesPerView: 4,
            autoplay: {
                delay: 3000,
            },
            breakpoints: {
                0: { slidesPerView: 2 },
                576: { slidesPerView: 3 },
                768: { slidesPerView: 4 },
                992: { slidesPerView: 5 },
            },
            });
        });
        });
    },

    push_berita : function(id){
        this.$router.push('/isi_berita?id='+id);
    },

    getSlider: function() {
        fetch(this.$store.state.URL_SLIDER, {
            method: "get",
            headers: {
                "content-type": "application/json",
            },
        })
            .then(res => res.json())
            .then(res_data => { 
                this.list_slider = res_data
                // console.log(res_data);
                
        });
    },



    getListBerita: function() {
        this.cek_load_data_list = true;
        fetch(this.$store.state.ADD_URL_BERITA+"homeOPD", {
            method: "POST",
            headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
            },
                body: JSON.stringify({
                unit_kerja: this.unit_kerja,
                kategori_id: this.kategori_id
                
            })
        })
            .then(res => res.json())
            .then(res_data => {
                this.list_berita = res_data;
                // this.cek_load_data = false;
                // console.log(res_data);
        });
    },

    getFoto: function() {
        fetch(this.$store.state.ADD_FOTO+'home', {
            method: "get",
            headers: {
                "content-type": "application/json",
            },
        })
            .then(res => res.json())
            .then(res_data => { 
                // console.log('🔍 list_foto:', res_data);
                this.list_foto = res_data
                // console.log(res_data);
                
        });
    },

    convert_tgl : function(dateString){
                  var date = new Date(dateString);
                  var getBulan = date.getMonth() + 1; var bulan = '';
                  if (getBulan == '1') {bulan = 'Jan'} 
                  else if(getBulan == '2') {bulan = 'Feb'}
                  else if(getBulan == '3') {bulan = 'Mar'}
                  else if(getBulan == '4') {bulan = 'Apr'}
                  else if(getBulan == '5') {bulan = 'Mei'}
                  else if(getBulan == '6') {bulan = 'Jun'}
                  else if(getBulan == '7') {bulan = 'Jul'}
                  else if(getBulan == '8') {bulan = 'Agt'}
                  else if(getBulan == '9') {bulan = 'Sep'}
                  else if(getBulan == '10') {bulan = 'Okt'}
                  else if(getBulan == '11') {bulan = 'Nov'}
                  else if(getBulan == '12') {bulan = 'Des'}



                  return date.getDate() + " " + bulan + " " + date.getFullYear();
    },



  },
}
</script>

<style scoped>
.hero {
  padding: 60px 0;
  background-color: #f8f9fa;
  text-align: center;
}
</style>
